import MapServiceModel from '@/models/MapServiceModel';
import doc             from '@widesk-core/decorators/doc';

/**
 * Opération custom `POST /imports/{id}/plan/analysis` : **le LANCEMENT d'une analyse de plan**
 * (`docs/PLAN_ANALYSE_ASYNC.md` §3).
 *
 * ## Elle ne rend plus l'analyse
 *
 * Elle répond `202` avec un reçu — l'identifiant et l'IRI d'une `PlanAnalysis` —, un consumer
 * fait le travail, et le corps se lit ensuite sur `GET /plan_analyses/{id}`
 * ({@link PlanAnalysisResultModel}). Le motif : une analyse lit le fichier quatre fois et
 * appellera bientôt un détecteur dans un autre processus ; ça n'a plus sa place dans une
 * requête que nginx coupe.
 *
 * Personne n'appelle ce modèle directement : `analysePlan()` lance, attend et rend le résultat
 * complet, de sorte que l'écran continue de voir une seule promesse.
 *
 * Appel : `setId(importId).save({ method: 'post', patchAttributes: { analysisRegion, layers } })`,
 * les deux facultatifs. `analysisRegion` suit la convention de `/plan/source` — absente elle
 * CONSERVE la zone en place, un rectangle vide l'EFFACE.
 */
@doc.path('/imports/{id}/plan/analysis')
export default class PlanAnalysisModel extends MapServiceModel {
	/**
	 * Identifiant de l'analyse créée.
	 *
	 * ⚠️ `planAnalysisId` et non `id` : l'URI de l'opération porte l'identifiant de l'IMPORT, et
	 * deux `id` de sens différents dans le même échange finissent toujours par se croiser. C'est
	 * aussi le nom que portent les événements Mercure de l'analyse.
	 */
	@doc.number declare planAnalysisId: number;

	/** Son IRI, à relire jusqu'à ce qu'elle aboutisse. */
	@doc.string declare planAnalysis: string;

	/** Son état au moment du lancement — `TO_DO`. */
	@doc.string declare status: Map_PlanAnalysisStatusReference;
}
